import { track, waLink } from "@/lib/api";

export const WaIcon = ({ className = "h-5 w-5 shrink-0" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.21 3.08.15.2 2.1 3.2 5.08 4.49.71.3 1.27.49 1.7.63.71.23 1.36.2 1.88.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.43 9.43 0 01-4.8-1.32l-.35-.2-3.57.93.96-3.48-.23-.36a9.4 9.4 0 01-1.44-5.02c0-5.2 4.24-9.44 9.45-9.44a9.4 9.4 0 016.68 2.77 9.38 9.38 0 012.76 6.68c0 5.2-4.24 9.44-9.45 9.44zm8.04-17.48A11.3 11.3 0 0012.04.69C5.78.69.68 5.79.68 12.05c0 2 .52 3.96 1.52 5.68L.59 23.6l6.02-1.58a11.33 11.33 0 005.43 1.38h.01c6.26 0 11.36-5.1 11.36-11.36 0-3.03-1.18-5.89-3.33-8.03z" />
  </svg>
);

export const WhatsAppButton = ({ wa, text, className = "", testId }) => (
  <a
    href={waLink(wa)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    onClick={() => track("whatsapp")}
    className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-[#25D366] px-6 py-3.5 font-semibold text-white shadow-[0_8px_24px_-8px_rgba(37,211,102,0.7)] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#1EBE5D] active:translate-y-0 ${className}`}
  >
    <WaIcon />
    <span>{text || wa?.button_text || "Book an Appointment on WhatsApp"}</span>
  </a>
);

export const MobileWhatsAppBar = ({ wa }) => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-sky-100 bg-white/95 p-3 backdrop-blur-md md:hidden" data-testid="mobile-whatsapp-bar">
    <WhatsAppButton wa={wa} testId="sticky-mobile-whatsapp-btn" className="w-full text-[15px]" />
  </div>
);
